import { call, put, select, takeLatest } from 'redux-saga/effects'
import { ClientDataConstants } from '../../../features/clientData/store/clientData.constants'
import { getServiceIdSelector, getUserSelector } from '../../../features/user/selectors'
import { CrewService } from '../../crew/services/crew.service'
import { IClientDataDoc } from '../../../services/clientData.service'
import { ICrewListMember } from '../../pcr/models/crewList.V1'
import { IUserState } from '../../user/store/user.types'
import { setErrorMessage, showToast } from '../../../components/apiErrorHandler/store/apiErrorHandler.actions'

export function* checkPinStatus() {
  const serviceId: string = yield select(getServiceIdSelector)
  const { userId }: IUserState = yield select(getUserSelector)
  const crewService = new CrewService(serviceId)

  const serviceUsers: IClientDataDoc = yield call([crewService, crewService.getCrewList])
  const pinErrorMessage =
    'We noticed you do not have a PIN associated with your user account. PINs are required to log into NOW when in an offline state. Please set up a PIN for your account next time you access emsCharts web portal to prevent future login issues.'

  if (serviceUsers) {
    const entity = serviceUsers.entity as Array<ICrewListMember>
    const userObj = entity.find((user) => Number(user.userId) === Number(userId))

    if (userObj) {
      const { pin: clientDataPin } = userObj

      if (!clientDataPin) {
        yield put(setErrorMessage(pinErrorMessage))
        yield put(showToast(true))
      }
    }
  }
}

export function* checkPinStatusSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], checkPinStatus)
}
